<template>
  <v-system-bar v-if="activeAlerts.length" color="white" :height="40" app class="pa-0">
    <v-scroll-x-transition mode="out-in">
      <template v-for="(alert, i) in activeAlerts">
        <c360-alert
          v-if="i === current"
          :alert="alert"
          :key="alert.id"
          @dismiss="onDismiss(alert)"
        />
      </template>
    </v-scroll-x-transition>
  </v-system-bar>
</template>

<script>
  import { C360Alert } from '../../../components/Alerts';
  import { getAlerts } from '../model';

  const DISMISSED_STORAGE_KEY = '@c360/ui/alerts/dismissed';
  let _interval = null;

  export default {
    name: 'C360Alerts',

    components: {
      C360Alert,
    },

    props: {
      url: {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        current: 0,
        alerts: [],
      };
    },

    computed: {
      activeAlerts() {
        const dismissed = JSON.parse(localStorage.getItem(DISMISSED_STORAGE_KEY)) || [];
        return this.alerts.filter((alert) => !dismissed.includes(alert.id));
      },
    },

    watch: {
      url: {
        handler() {
          getAlerts(this.$c360.product, this.url).then((alerts) => (this.alerts = alerts));
          this.startCarousel();
        },
        immediate: true,
      },
    },

    methods: {
      onDismiss(alert) {
        this.alerts = this.alerts.filter((a) => a.id !== alert.id);
        const dismissed = JSON.parse(localStorage.getItem(DISMISSED_STORAGE_KEY)) || [];
        dismissed.push(alert.id);
        localStorage.setItem(DISMISSED_STORAGE_KEY, JSON.stringify(dismissed));
        this.showNextAlert();
      },
      startCarousel() {
        _interval = setInterval(() => {
          if (this.activeAlerts.length <= 1) return;
          this.showNextAlert();
        }, 1000 * 10);
      },
      showNextAlert() {
        this.current = this.current + 1 >= this.activeAlerts.length ? 0 : this.current + 1;
      },
    },

    beforeDestroy() {
      clearInterval(_interval);
    },
  };
</script>
